export type TKeywordsResponse = {
  data: {
    en: {
      title: string;
      url: string;
    }[];
    ru: {
      title: string;
      url: string;
    }[];
  };
};
